import React from 'react';

export function Switzerland(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="513" height="342" fill="#FF0000"/>
      <rect x="218" y="96" width="77" height="150" fill="white"/>
      <rect x="181" y="133" width="151" height="76" fill="white"/>
    </svg>
  );
}
